import { React, Link } from '../../libraries'
import { HandleError } from '../atom'
import '../../assets/styles/Responsive.css'

const DateFormat = ({ dateTime }) => {
  let dateFormatValue = new Intl.DateTimeFormat("en-GB", {
    year: "numeric",
    day: "2-digit",
    month: "long"
  }).format(new Date(dateTime))

  dateFormatValue = dateFormatValue.split(' ')
  return (dateFormatValue[1] + " " + dateFormatValue[0] + ", " + dateFormatValue[2])
}

export const DealsList = ({ data }) => {
  return (
    <>
      <div className="w-full flex flex-wrap py-4 cursor-pointer hover:bg-gray-200 hover:shadow-md deals-list">
        <div className="sm:w-3/12 w-full">
          <img src={`${data.image}`} onError={HandleError} alt={`${data.specialDeals.title}`} className="w-full sm:rounded-r-md rounded-md object-cover shadow" style={{ height: "300px" }} />
        </div>
        <div className="flex flex-wrap md:content-between content-start sm:w-6/12 w-full md:pl-10 sm:pl-5 pl-0 md:pr-6 pr-0 text-left sm:mt-0 mt-3">
          <p className="w-full md:flex-column text-lg">{`${data.specialDeals.title}`}</p>
          <div className="w-full md:flex-column lg:mt-5 mt-2">
            <p className="text-sm" dangerouslySetInnerHTML={{ __html: `${data.specialDeals.content !== "" && data.specialDeals.content.replace(/(<([^>]+)>)/ig, "").length > 245 ? data.specialDeals.content.replace(/(<([^>]+)>)/ig, "").substring(0, 245)+'...' : data.specialDeals.content.replace(/[^a-zA-Z ]/g, "")}` }}></p>
          </div>
          <p className="w-full md:flex-column text-md mt-auto mb-4">Promotion Valid Until <DateFormat dateTime={`${data.specialDeals.expire !== '' ? data.specialDeals.expire : ''}`} /></p>
          {data !== '' && data.tags !== undefined && data.tags !== '' ? (
            data.tags.map((res, index) => {
                return (res !== "" ?
                  <div key={index} className="w-auto mr-2">
                    <button className="px-6 rounded-md text-sm text-black-100 py-1 border-2 uppercase ml-auto" style={{ borderColor: "#d4d4d4" }}>{`${res}`}</button>
                  </div>
                : "")
            })
          ) : ('')}
        </div>
        <div className="flex sm:w-3/12 w-full sm:pl-5 pl-0 sm:pr-5 pr-0 sm:mt-0 mt-3">
          <Link to={`/hotel-overview/placeid-${data.placeId !== undefined && data.placeId}`} className="px-2 rounded-md text-sm text-black py-2 lg:w-7/12 w-full my-auto ml-auto" style={{ backgroundColor: "#fed500" }}>View Details</Link>
        </div>
      </div>
    </>
  )
}